import {filters} from './state';

/**
 * Establecer un valor para la variable preloader.
 */
export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

/**
 * Establecer un valor para la variable contacts.
 */
export function setContacts(state, contacts) {
    state.contacts = contacts;
}

/**
 * Establecer un valor para la variable lines.
 */
export function setLines(state, lines) {
    state.lines = lines;
}

/**
 * Establecer el valor por defecto de la variable filters.
 */
export function resetFilters(state) {
    state.filters = filters();
}



// WEBPACK FOOTER //
// ./src/modules/replacement_points_of_sale/mutations.js